import { Box } from '@mui/material'
import React from 'react'

function Error({children}) {
  return (
    <Box sx={{ textAlign: "center", width: "100%" }}>{children}</Box>
  )
}

export default Error